var _polygon, _circle, _circle2, _circle3, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _line, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadershipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leadershipGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#5F7A61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F5F0E6"
    }
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12,48 20,36 28,44 32,32 36,44 44,36 52,48 12,48",
    fill: "url(#leadershipGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 2,
    fill: "#E5DECF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 36,
    r: 3,
    fill: "#E5DECF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 2,
    fill: "#E5DECF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20,36 18,28 22,28",
    fill: "#5F7A61"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "32,32 30,20 34,20",
    fill: "#5F7A61"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "44,36 42,28 46,28",
    fill: "#5F7A61"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 52,
    width: 4,
    height: 8,
    fill: "#1C1917"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 52,
    width: 4,
    height: 8,
    fill: "#1C1917"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 52,
    width: 4,
    height: 8,
    fill: "#1C1917"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 48,
    x2: 52,
    y2: 48,
    stroke: "#E5DECF",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 56,
    r: 4,
    fill: "#5F7A61",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipIcon);
export default __webpack_public_path__ + "static/media/leadership-icon.5f5d5c252ddaa2159e3995887d8d3f37.svg";
export { ForwardRef as ReactComponent };